import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const WS_BASE = BACKEND_URL.replace(/^http/, "ws");

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cadence_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Registered by AuthProvider so a 401 reuses the canonical logout (clear the
// stored token + drop the router back to the auth screen) instead of a second,
// divergent token-clear path.
let onUnauthorized = null;
export function setUnauthorizedHandler(fn) { onUnauthorized = fn; }

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if (status === 401) {
      if (onUnauthorized) onUnauthorized();
      else localStorage.removeItem("cadence_token");
    } else if (status >= 500 && !error.config?.skipErrorToast) {
      // Call sites that catch-and-toast themselves pass { skipErrorToast: true }.
      // Stable per-endpoint id so polling calls update one toast instead of stacking.
      toast.error(formatApiError(error.response?.data?.detail), {
        id: `api-5xx:${error.config?.url || "request"}`,
      });
    }
    return Promise.reject(error);
  }
);

export async function downloadHostAgent() {
  const { data } = await api.get("/host-agent/download", { responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = "cadence-host-agent.zip";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
